import { useTranslation } from 'react-i18next'

import useDeleteCard from '@features/payment/hooks/useDeleteCard'
import { useManagePaymentMethods } from '@features/payment/hooks/useManagePaymentMethods'

import Button from '@shared/ui/button'

import styles from './styles.module.scss'

export default function DeleteCardModal ({ id }: { id?: string }) {
  const { t: tc } = useTranslation('common')
  const { handleRemove } = useManagePaymentMethods()
  const { closeDeleteModal } = useDeleteCard()

  const handleClearCart = () => {
    if (id) {
      handleRemove(id)
    }
    closeDeleteModal()
  }

  return (
    <div className={styles.modal}>
      <Button onClick={handleClearCart} size="large">
        {tc('yes')}
      </Button>
      <Button onClick={closeDeleteModal} theme="grey">
        {tc('no')}
      </Button>
    </div>
  )
}
